var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 20H16V13.001C16 11.081 15.153 10.01 13.634 10.01C11.981 10.01 11 11.126 11 13.001V20H7V7H11V8.462C11 8.462 12.255 6.26 15.083 6.26C17.912 6.26 20 7.986 20 11.558V20ZM2.442 4.921C1.093 4.921 0 3.819 0 2.46C0 1.102 1.093 0 2.442 0C3.79 0 4.883 1.102 4.883 2.46C4.884 3.819 3.79 4.921 2.442 4.921ZM0 20H5V7H0V20Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.0f72de1dd0fa723642e9c021001ac286.svg";
export { ForwardRef as ReactComponent };